module.exports = __webpack_public_path__ + "img/saturnina.5ac82d78.png";